import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_TraumaAssessment = ({ itemsRef, showErrorFor }) => {

	return (
		<form id='NHBC_TraumaAssessment' className='file-pdf-document'>

			<div className='file-template'>

				<p>
					<span className='eleHeader'>Assessment Techniques:</span>
					<textarea id="txtAssessmentTechniques" name="txtAssessmentTechniques" className='add-only '></textarea>
				</p>
				<p>
					<span className='eleHeader'>Referral Information:</span>
					Consumer was referred to New Heights Behavioral Consultants, Inc., by <input type='text' id="txtReferralInfo_1" name="txtReferralInfo_1" className='add-only  w-250 custom-add-only' />
					County Department of Family and Children Services (DFCS) on date <input type='date' id="txtReferralInfo_2" name="txtReferralInfo_2" className='add-only  w-150 custom-add-only' />. Consumer was referred to the agency by <input type='text' id="txtReferralInfo_3" name="txtReferralInfo_3" className='add-only  w-250 custom-add-only' />, DFCS Foster Care/Permanency
					Case Manager/Supervisor, for the purpose of an assessment to screen and assess for any indicators of
					trauma factors that may be clinically significant in the overall treatment and care of the consumer.
				</p>
				<p>
					<span className='eleHeader'>Background Information:</span>
					Consumer is a <input type='text' id="txtBackground_1" name="txtBackground_1" className='add-only w-250 custom-add-only' /> year old <input type='text' id="txtBackground_2" name="txtBackground_2" className='add-only w-250 custom-add-only' /> (race/ethnicity), <select id="ddlBackground_3" name="ddlBackground_3" className='add-only w-250 custom-add-only'>
						<option value=""></option>
						<option value="male">male</option>
						<option value="female">female</option>
					</select> who currently is residing in a &nbsp;
					<select id="ddlBackground_10" name="ddlBackground_10" className='add-only w-150 custom-add-only'>
						<option value=""></option>
						<option value="foster home">foster home</option>
						<option value="child caring institution">child caring institution</option>
					</select>.
					Consumer has lived in this location for <input type='text' id="txtBackground_4" name="txtBackground_4" className='add-only w-200 custom-add-only' /> (timeframe). Consumer has
					<input type='text' id="txtBackground_5" name="txtBackground_5" className='add-only w-200 custom-add-only' /> siblings. Prior to coming into the custody of <input type='text' id="txtBackground_6" name="txtBackground_6" className='add-only w-200 custom-add-only' /> County DFCS, consumer was residing with <input type='text' id="txtBackground_7" name="txtBackground_7" className='add-only w-200 custom-add-only' />. Consumer entered foster care on <input type='date' id="txtBackground_8" name="txtBackground_8" className='add-only w-200 custom-add-only' /> due to <input type='text' id="txtBackground_9" name="txtBackground_9" className='add-only w-200 custom-add-only' />.
				</p>
				<p>
					<span className='eleHeader'>Educational History:</span>
					<textarea id="txtEducationalHistory" name="txtEducationalHistory" className='add-only'></textarea>
				</p>
				<p>
					<span className='eleHeader'>Developmental and Medical History:</span>
					<textarea id="txtDevelopmentMedicalHistory" name="txtDevelopmentMedicalHistory" className='add-only'></textarea>
				</p>
				<p>
					<span className='eleHeader'>Legal History:</span>
					<textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only'></textarea>
				</p>
				<h4>

				</h4>
				<p>
					<span className='eleHeader'>Mental Health Status & History:</span>
					Consumer was <input type='text' id="txtMH_1" name="txtMH_1" className='add-only w-200 custom-add-only' /> at the time of the assessment. His/her affect was
					<input type='text' id="txtMH_2" name="txtMH_2" className='add-only w-200 custom-add-only' /> and mood <input type='text' id="txtMH_1" name="txtConsumerMood" className='add-only w-200 custom-add-only' />. At the time of the assessment consumer was <input type='text' id="txtMH_3" name="txtMH_3" className='add-only w-200 custom-add-only' />. His/her memory was intact for <input type='text' id="txtMH_4" name="txtMH_4" className='add-only w-200 custom-add-only' />
					memory. There <select id="ddlMH_5" name="ddlMH_5" className='add-only w-200 custom-add-only'>
						<option value=""></option>
						<option value="were no">were no</option>
						<option value="were">were</option>
					</select> signs of auditory, visual, or tactile hallucinations. He/she was
					<input type='text' id="txtMH_6" name="txtMH_6" className='add-only w-200 custom-add-only' /> and oriented x <input type='text' id="txtMH_7" name="txtMH_7" className='add-only w-200 custom-add-only' />.
					Reports showed that the consumer's family &nbsp;
					<select id="ddlMH_8" name="ddlMH_8" className='add-only w-200 custom-add-only'>
						<option value=""></option>
						<option value="has">has</option>
						<option value="does not have"> does not have </option>
					</select> a psychiatric history. Consumer
					<select id="ddlMH_9" name="ddlMH_9" className='add-only w-200 custom-add-only'>
						<option value=""></option>
						<option value="has">has</option>
						<option value="does not have any">does not have any</option>
					</select> previous psychiatric hospitalizations and &nbsp;
					<select id="ddlMH_10" name="ddlMH_10" className='add-only w-200 custom-add-only'>
						<option value=""></option>
						<option value="has not">has not</option>
						<option value="has">has</option>
					</select> been treated with psychotropic medications.
					<em>(Include information about past treatment and where, diagnosis and list medications, if any)</em>
				</p>
				<p>
					<span className='eleHeader'>Trauma History:</span>
					During the assessment, this assessor assessed for overt statements of reported physical,
					sexual, and emotional abuse. The assessor probed to identify if there was any abuse,
					and the frequency, intensity and duration of any reported abuse. At the time of
					the assessment the consumer reported
					<input type='text' id="txtTrauma_1" name="txtTrauma_1" className='add-only' />
					physical, emotional or sexual abuse. Assessor further assessed any other convert
					signs and symptoms of abuse by using the following tool(s) below. The assessment
					instruments and results are discussed below.
				</p>
				<h4>Test Results</h4>
				<p>
					<span className='eleHeader'>Trauma Symptom Checklist for Young Children (TSCYC):</span>
					This assessment instrument is a standardized parent/caretaker report test of trauma
					symptoms in children ages 5 to 12 years. The instrument is used to assess trauma
					symptoms by looking at eight clinical scales: Anxiety, Depression, Anger/Aggression,
					Posttraumatic Stress-Intrusion, Posttraumatic Stress-Avoidance, Posttraumatic Stress-Arousal,
					Dissociation and Sexual Concerns, and a summary of posttraumatic stress scale (Posttraumatic
					Stress Total). There is also a validity scale.
				</p>
				<p>
					For all clinical scales except the Posttraumatic Stress Total with a T score less
					than 64 are considered normal, a T score between 65 and 69 are deemed potentially
					problematic, and a T score at or above 70 are interpreted to be clinically significant.
					For the Posttraumatic Stress Total a T score equal to or greater than 70 suggest
					relatively severe posttraumatic disturbance, and a T score in the 65 to 69 range
					suggests mild to moderate posttraumatic stress.
				</p>
				<p>
					Based on the results of the TSCYC the consumer did/didn't have any clinically significant
					scores on the following scales:<br />
					Anxiety (T score = <input type='text' id="txtAnxietyScore" name="txtAnxietyScore" className='add-only w-150 custom-add-only w-150 custom-add-only w-150 custom-add-only' />),<br />
					Depression (T score = <input type='text' id="txtDepressionScore" name="txtDepressionScore" className='add-only w-150 custom-add-only' />),<br />
					Anger/Aggression (T score = <input type='text' id="txtAggressionScore" name="txtAggressionScore" className='add-only w-150 custom-add-only' />),<br />
					Posttraumatic Stress-Intrusion (T score = <input type='text' id="txtStressScore" name="txtStressScore" className='add-only w-150 custom-add-only' />),<br />
					Posttraumatic Stress-Avoidance (T score = <input type='text' id="txtStressAvoidenceScore" name="txtStressAvoidenceScore" className='add-only w-150 custom-add-only' />),<br />
					Posttraumatic Stress-Arousal (T score = <input type='text' id="txtStressArousalScore" name="txtStressArousalScore" className='add-only w-150 custom-add-only' />),<br />
					Posttraumatic Stress Total (T score = <input type='text' id="txtStressTotal" name="txtStressTotal" className='add-only w-150 custom-add-only' />),<br />
					Dissociation (T score = <input type='text' id="txtDissociation" name="txtDissociation" className='add-only w-150 custom-add-only' />),<br />
					Sexual Concerns (T score = <input type='text' id="txtSexualConcern" name="txtSexualConcern" className='add-only w-150 custom-add-only' />).<br />
					The consumer's validity scale T score of <input type='text' id="txtTScore" name="txtTScore" className='add-only w-150 custom-add-only' />
					fell in the <input type='text' id="txtFell" name="txtFell" className='add-only w-150 custom-add-only' /> range, therefore the results of the TSCYC
					are considered valid and accurate/invalid.
					<b>(If any of the scales fell in the clinically significant range, then address what
						this means according to the TSCYC manual)</b>
				</p>
				<p>
					Further assessment is <select id="ddlFurtherAssessment" name="ddlFurtherAssessment" className='add-only w-250 custom-add-only'>
						<option value=""></option>
						<option value="needed">needed</option>
						<option value="not needed">not needed</option>
					</select> to determine if the consumer has experienced any trauma. Additional testing was not completed due to the consumer's age.
				</p>
				<h4>Diagnostic Impressions</h4>
				<table>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>AXIS I:</span>
							<input type='text' id="txtAxisI" name="txtAxisI" className='add-only' />
						</td>
						<td className='w-375'>
							<span className='eleHeader'>AXIS II:</span>
							<input type='text' id="txtAxisII" name="txtAxisII" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>AXIS III:</span>
							<input type='text' id="txtAxisIII" name="txtAxisIII" className='add-only' />
						</td>
						<td className='w-375'>
							<span className='eleHeader'>AXIS IV:</span>
							<input type='text' id="txtAxisIV" name="txtAxisIV" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>AXIS V - GAF:</span>
							<input type='text' id="txtAxisV" name="txtAxisV" className='add-only' />
						</td>
						<td>&nbsp;</td>
					</tr>
				</table>
				<p>
					<span className='eleHeader'>Conclusions & Treatment Recommendations:</span>
					The purpose of the trauma assessment is as follows:
				</p>
				<ul>
					<li>To determine appropriate follow-up and referral</li>
					<li>To determine imminent danger requiring urgent response</li>
					<li>To identify need for trauma-specific services or other psychological testing</li>
					<li>To open possibility of later disclosure if consumer decides not to talk about trauma experiences at early stage</li>
				</ul>
				<p>
					The results of the trauma assessment indicate that the consumer
					<select id="" name="" className='add-only'>
						<option value=""></option>
						<option value="does">does</option>
						<option value="does not">does not</option>
					</select>
					appear to have clinically significant trauma at the time of the assessment.
					<b>(If clinically significant then explain why.)</b> Furthermore, there appeared not
					to be imminent danger requiring urgent response at the time of this assessment.
				</p>
				<p>
					It is recommended that the consumer receives <input type='text' id="txtRecommendation" name="txtRecommendation" className='add-only w-250 custom-add-only' />,
					<input type='text' id="txtRecieves" name="txtRecieves" className='add-only w-250 custom-add-only' />, and <input type='text' id="txtRecieves1" name="txtRecieves1" className='add-only w-250 custom-add-only' />. Additionally, the consumer can benefit from pro-social activities (recreational sports, art, dance, music,
					etc.) in the community to assist with coping with the separation from his/her family.
				</p>
				<p>If you have any other questions, please call us at 770-460-0970.</p>
				<p>Respectfully,</p>
				<p>
					Robert L. Clemons, LPC<br />
					License #LPC004041<br />
					New Heights Behavioral Consultants
				</p>


			</div>
		</form>

	)
}  